import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, continuity, continuityCnname, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

let treeChildren = (index, data, Vue) => {
  var arr = [];
  if (data) {
    for (let i = 0; i < 10; i++) {
      var obj = {};
      obj.title = `${i}`;
      obj.align = 'center';
      // obj.width = ' 24';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        // reutrn <span class="lost_info">{row.row.ball_json[name].nums[i]}</span>;
        if (row.row.ball_json[name].nums[i] == 0) {
          // data[row.index].show = true;
          // return <span class="red">{row.row.ball_json[name].nums[i]}</span>;
          return <span class="red">{data[row.index].List[index]}</span>;
        } else if (Vue.divideList[name].nums[i] > row.index) {
          return <span class="divide_lost_info lost_info">{row.row.ball_json[name].nums[i]}</span>;
        } else {
          return <span class="lost_info">{row.row.ball_json[name].nums[i]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let shapeChildren = data => {
  var arr = [];
  var shape = ['豹子', '顺子', '对子', '半顺', '杂六'];
  var str = ['bz', 'sz', 'dz', 'bs', 'zl'];
  if (data) {
    for (let i = 0; i < 5; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '24';
      obj.className = `tree_table_children`;
      obj.render = (h, row) => {
        if (row.row.shape[str[i]] == 0) {
          return <span class="table_shape_red">{shape[i]}</span>;
          // } else {
          //   return <span class="table_shape">{row.row.shape[str[i]]}</span>;
          // }
        } else if (data[0].shape[str[i]] > row.index) {
          return <span class="divide_lost_info lost_info">{row.row.shape[str[i]]}</span>;
        } else {
          return <span class="lost_info">{row.row.shape[str[i]]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let joinChildren = data => {
  var arr = [];
  var shape = ['组三', '组六', '豹子'];
  var str = ['zs', 'zl', 'bz'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '24';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        if (row.row.join[str[i]] == 0) {
          return <span class="table_join_red">{shape[i]}</span>;
          // } else {
          //   return <span class="table_join">{row.row.join[str[i]]}</span>;
          // }
        } else if (data[0].join[str[i]] > row.index) {
          return <span class="divide_lost_info lost_info">{row.row.join[str[i]]}</span>;
        } else {
          return <span class="lost_info">{row.row.join[str[i]]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

let lostChildren = index => {
  var arr = [];
  for (let i = 0; i < 10; i++) {
    var obj = {};
    obj.title = `${i}`;
    obj.align = 'center';
    // obj.width = '24';
    obj.className = `lost_table_children_${i}`;
    obj.render = (h, row) => {
      var name = `ball${index}`;
      var key = row.row.key;
      var n = row.row.lost.ballJson[name].nums[i];
      if (key != 'averageOmit') {
        return <span>{n[key] ? n[key] : 0}</span>;
      }
    };
    arr.push(obj);
  }
  return arr;
};

let xtLostChildren = (data, index) => {
  var arr = [];
  var shape = ['豹子', '顺子', '对子', '半顺', '杂六'];
  var str = ['bs', 'bz', 'dz', 'sz', 'zl'];
  for (let i = 0; i < shape.length; i++) {
    var obj = {};
    obj.title = `${shape[i]}`;
    obj.align = 'center';
    // obj.width = '24';
    obj.className = `join_table_children`;
    obj.render = (h, row) => {
      var o = {
        0: 'front',
        1: 'midle',
        2: 'tail'
      };
      var name = str[i];
      var key = row.row.key;
      var n = row.row.lost.form_json[o[index]].shape[name];
      return <span class="table_join">{n[key] ? n[key] : 0}</span>;
    };
    arr.push(obj);
  }
  return arr;
};
let zxLostChildren = (data, index) => {
  var arr = [];
  var shape = ['组三', '组六', '豹子'];
  var str = ['zs', 'zl', 'bz'];
  for (let i = 0; i < shape.length; i++) {
    var obj = {};
    obj.title = `${shape[i]}`;
    obj.align = 'center';
    // obj.width = '24';
    obj.className = `join_table_children`;
    obj.render = (h, row) => {
      var o = {
        0: 'front',
        1: 'midle',
        2: 'tail'
      };
      var name = str[i];
      var key = row.row.key;
      var n = row.row.lost.form_json[o[index]].join[name];
      return <span class="table_join">{n[key] ? n[key] : 0}</span>;
    };
    arr.push(obj);
  }
  return arr;
};
// bz:豹子，数值为遗漏数，0是本期中奖
// sz:顺子，数值为遗漏数，0是本期中奖
// dz:对子，数值为遗漏数，0是本期中奖
// bs:半顺，数值为遗漏数，0是本期中奖
// zl:杂六，数值为遗漏数，0是本期中奖

const ssc = data => {
  let list = Vue => {
    let arr = [
      {
        title: '期数',
        align: 'center',
        key: 'issue_id',
        className: `table_issueId`,
        width: 130
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 130,
        render: (h, { row }) => <span class="issue_result">{row.balls.split(',').join('')}</span>
      }
    ];
    var a = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
    for (let i = Vue.checkedStart; i < Vue.checkedEnd; i++) {
      let obj = {};
      let e = a[i];
      obj.title = `第${e}球号码走势`;
      obj.align = 'center';
      obj.width = '300';
      obj.key = 'resultStr';
      obj.className = `table_info_column_${i}`;
      obj.children = treeChildren(i, data, Vue);
      arr.push(obj);
    }
    arr.push(
      {
        title: '形态',
        align: 'center',
        className: `table_issueId`,
        children: shapeChildren(data),
        width: 150
      },
      {
        title: '组选类型',
        align: 'center',
        className: `table_issueId`,
        children: joinChildren(data),
        width: 150
      }
    );

    return arr;
  };
  let lostList = Vue => {
    let arr = [
      {
        title: '数据统计',
        align: 'center',
        key: 'name',
        className: `table_issueId`,
        width: 260
      }
    ];
    var a = ['一', '二', '三', '四', '五'];
    var indexs = [1, 2, 3, 4, 5];
    var checkedStart = Vue.checkedStart;
    for (let i = checkedStart; i < checkedStart + 3; i++) {
      let obj = {};
      let e = a[i];
      obj.title = `第${e}球`;
      obj.align = 'center';
      obj.className = `table_info_column_${i}`;
      obj.children = lostChildren(indexs[i]);
      arr.push(obj);
    }
    arr.push(
      {
        title: '形态',
        align: 'center',
        className: `table_issueId`,
        children: xtLostChildren(data, checkedStart)
      },
      {
        title: '组选类型',
        align: 'center',
        className: `table_issueId`,
        children: zxLostChildren(data, checkedStart),
        width: 150
      }
    );
    return arr;
  };
  return { list, lostList };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Xingtaizoushi/columns/ssc.js